<template>
  <div>
    <modal name="customer-modal-create" width="80%" height="90%">
      <ion-header>
        <ion-toolbar>
          <ion-title>{{ $t('backoffice.form.fields.createNewCustomer') }}</ion-title>
          <ion-buttons slot="end">
            <ion-button @click="$modal.hide('customer-modal-create')">❌</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <div class="ion-padding" style="height: 80%; overflow: scroll;">
        <CustomerForm :fromInvoice="true" :redirect="false" :isModal="true" :isCustomerModal="true"
          @dismiss-modal="handleDismissedCreateCustomerModal" />
      </div>
    </modal>
    <modal name="subscriber-modal-create" width="80%" height="90%">
      <ion-header>
        <ion-toolbar>
          <ion-title>{{ $t('backoffice.form.titles.suscriptionNewTitle') }}</ion-title>
          <ion-buttons slot="end">
            <ion-button @click="$modal.hide('subscriber-modal-create')">❌</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <div class="ion-padding" style="height: 80%; overflow: scroll;">
        <SubscriberForm :fromInvoice="true" :redirect="false" :isModal="true" :isCustomerModal="true"
          @dismiss-modal="handleDismissedCreateSubscriberModal" />
      </div>
    </modal>
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-card>
            <!-- <ion-card-header>
              <ion-title>Interaction Details</ion-title>
            </ion-card-header> -->
            <ion-card-content>
              <ion-item>
                <ion-label position="floating">{{ $t('backoffice.interactions.lastContacted') }}</ion-label>
                <ion-datetime @ionChange="lastContacted = $event.target.value" v-bind:value="lastContacted" display-format="MM/DD/YYYY"></ion-datetime>
                <ion-textarea style="margin-top: 0;" class="input-style" @input="notesLastContacted = $event.target.value" :value="notesLastContacted" :placeholder="$t('backoffice.interactions.notesLastContacted')"></ion-textarea>
              </ion-item>
              <ion-item>
                <ion-label position="floating">{{ $t('backoffice.interactions.nextFollowUp') }}</ion-label>
                <ion-datetime @ionChange="nextFollowUp = $event.target.value" v-bind:value="nextFollowUp" display-format="MM/DD/YYYY"></ion-datetime>
                <ion-textarea style="margin-top: 0;" class="input-style" @input="notesNextFollowUp = $event.target.value" :value="notesNextFollowUp" :placeholder="$t('backoffice.interactions.notesNextFollowUp')"></ion-textarea>
              </ion-item>
              <ion-item>
                <ion-label position="floating">{{ $t('backoffice.interactions.preferredContactTime') }}</ion-label>
                <ion-row>
                  <ion-col>
                    <ion-input @input="preferredContactTime = $event.target.value" v-bind:value="preferredContactTime" type="time"></ion-input>
                  </ion-col>
                  <ion-col>
                    <ion-input @input="preferredContactToTime = $event.target.value" v-bind:value="preferredContactToTime" type="time"></ion-input>
                  </ion-col>
                </ion-row>
                <ion-textarea style="margin-top: 0;" class="input-style" @input="notesContactToTime = $event.target.value" v-bind:value="notesContactToTime" :placeholder="$t('backoffice.interactions.notesContactToTime')"></ion-textarea>
              </ion-item>
            </ion-card-content>
          </ion-card>
          <ion-button expand="block" color="primary" :disabled="!isValidForm()" @click="showCustomerList">
            {{ $t('backoffice.interactions.selectCustomer') }}
          </ion-button>
          <ion-button expand="block" color="primary" :disabled="!isValidForm()" @click="showSubscriberList">
            {{ $t('backoffice.interactions.selectSubscriber') }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</template>

<script>
import { DateTime } from 'luxon';
import Swal from 'sweetalert2';
import { Api } from '../../backoffice/api/api.js';
import CustomerForm from '../../backoffice/views/CustomerForm.vue';
import SubscriberForm from '../../backoffice/views/SubscriberForm.vue';

export default {
  name: 'Interaction',
  components: {
    CustomerForm,
    SubscriberForm
  },
  data() {
    return {
      lastContacted: DateTime.local().toFormat('yyyy-MM-dd'),
      nextFollowUp: DateTime.local().toFormat('yyyy-MM-dd'),
      preferredContactTime: "",
      notesLastContacted: '',
      notesNextFollowUp: '',
      preferredContactToTime: '',
      notesContactToTime: '',
      interactions: [],
      addInteraction: false,
      selectedCustomer: null,
      customers: [],
      subscribers: [],
      selectedSubscriber: null
    }
  },
  methods: {
    handleDismissedCreateCustomerModal(data) {
      this.$modal.hide('customer-modal-create');
    },
    handleDismissedCreateSubscriberModal(data) {
      this.$modal.hide('subscriber-modal-create');
    },
    async showCustomerList() {
      try {
        const response = await Api.getCustomersByRestaurant('customer');
        this.customers = response.data.sort((a, b) => 
          parseInt(b._id.substring(0, 8), 16) - parseInt(a._id.substring(0, 8), 16)
        );

        const { value: customerId, isDismissed } = await Swal.fire({
          title: this.$t('backoffice.interactions.selectCustomer'),
          input: 'select',
          inputOptions: this.customers.reduce((options, customer) => {
            options[customer._id] = customer.Name + ' - ' + customer.EmailAddress;
            return options;
          }, {}),
          inputPlaceholder: this.$t('backoffice.interactions.selectCustomerInputPlaceholder'),
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: this.$t('backoffice.interactions.selectCustomer'),
          denyButtonText: this.$t('backoffice.interactions.createCustomer'),
          denyButtonColor: '#3085d6',  // Blue color, can be changed to any color HEX
          cancelButtonText: 'Cancel',
          backdrop: false,
          inputValidator: (value) => {
            return new Promise((resolve) => {
              if (value || Swal.isLoading()) {
                resolve();
              } else {
                resolve('Select a customer');
              }
            });
          },
          preDeny: () => {
            this.$nextTick(() => {
              this.$modal.show('customer-modal-create');
            });
            return;
          }
        });

        // If a customer is selected
        if (customerId) {
          this.selectedCustomer = this.customers.find(c => c._id === customerId);
          const isCustomer = true;
          await this.saveInteraction(customerId, isCustomer);
        }
      } catch (error) {
        console.error('Error getting customer:', error);
        Swal.fire('Error', 'to get customers', 'error');
      }
    },

    async showSubscriberList(data = {}) {
      try {
        const response = await Api.fetchAllFiltered('Subscriber', data);
        this.subscribers = response.data.sort((a, b) => 
          parseInt(b._id.substring(0, 8), 16) - parseInt(a._id.substring(0, 8), 16)
        );

        const { value: subscriberId } = await Swal.fire({
          title: this.$t('backoffice.interactions.selectSubscriber'),
          input: 'select',
          inputOptions: this.subscribers.reduce((options, subscriber) => {
            options[subscriber._id] = subscriber.Name + ' - ' + subscriber.Email;
            return options;
          }, {}),
          inputPlaceholder: this.$t('backoffice.interactions.selectSubscriberInputPlaceholder'),
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: this.$t('backoffice.interactions.selectSubscriber'),
          denyButtonText: this.$t('backoffice.interactions.createSubscriber'),
          denyButtonColor: '#3085d6',  // Color blue, can be changed to any color HEX
          cancelButtonText: this.$t('backoffice.interactions.cancel'),
          backdrop:false,
          inputValidator: (value) => {
            return new Promise((resolve) => {
              if (value) {
                resolve();
              } else {
                resolve('Select a subscriber');
              }
            });
          },
          preDeny: () => {
            this.$nextTick(() => {
              this.$modal.show('subscriber-modal-create');
            });
            return;
          }
        });

        if (subscriberId) {
          this.selectedSubscriber = this.subscribers.find(c => c._id === subscriberId);
          const isCustomer = false;
          await this.saveInteraction(subscriberId, isCustomer);
        }
      } catch (error) {
        console.error('Error getting subscriber:', error);
        Swal.fire('Error', 'to get subscribers', 'error');
      }
    },

    isValidForm() {
      return (
        this.notesLastContacted.trim() !== '' ||
        this.notesNextFollowUp.trim() !== '' ||
        this.notesContactToTime.trim() !== ''
      );
    },
    
    async saveInteraction(id, isCustomer) {
      try {
        const collection = isCustomer ? 'Customer' : 'Subscriber';
        const sourceList = isCustomer ? this.customers : this.subscribers;
        const item = sourceList.find(item => item._id === id);
        
        if (!item) {
          throw new Error(`${isCustomer ? 'Customer' : 'Subscriber'} not found`);
        }

        const existingInteractions = item.interactions || [];
        
        const newInteraction = { 
          lastContacted: this.lastContacted, 
          notesLastContacted: this.notesLastContacted, 
          nextFollowUp: this.nextFollowUp,
          notesNextFollowUp: this.notesNextFollowUp,
          preferredContactTime: this.preferredContactTime,
          preferredContactToTime: this.preferredContactToTime,
          notesContactToTime: this.notesContactToTime,
          selected: 1,
          _id: Date.now().toString(),
          isCustomer: isCustomer,
          date: DateTime.local().toISO()
        };
        
        const updatedInteractions = [...existingInteractions, newInteraction];
        const interactionData = {
          _id: id,
          interactions: updatedInteractions
        };

        try {
          const response = await Api.putIn(collection, interactionData);
          
          // Actualizar el store correspondiente
          const storePath = isCustomer ? 'backConfig.allCustomer' : 'backConfig.subscriber';
          const index = this.$store.state[storePath.split('.')[0]][storePath.split('.')[1]]
            .findIndex(i => i._id === id);
            
          if (index !== -1) {
            this.$store.state[storePath.split('.')[0]][storePath.split('.')[1]][index] = 
              { ...this.$store.state[storePath.split('.')[0]][storePath.split('.')[1]][index], ...interactionData };
          }

          // Mostrar mensaje de éxito
          Swal.fire({
            title: isCustomer 
              ? this.$t('backoffice.list.messages.messageEditSuccessCustomer')
              : this.$t('backoffice.list.messages.messageEditSuccessSuscriptor'),
            icon: 'success',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          });

          // Limpiar el formulario
          this.lastContacted = DateTime.local().toFormat('yyyy-MM-dd');
          this.nextFollowUp = DateTime.local().toFormat('yyyy-MM-dd');
          this.notesLastContacted = '';
          this.notesNextFollowUp = '';
          this.preferredContactTime = '';
          this.preferredContactToTime = '';
          this.notesContactToTime = '';
          this.selectedCustomer = null;
          this.selectedSubscriber = null;

          return response;
        } catch (error) {
          console.error(`Error saving ${isCustomer ? 'customer' : 'subscriber'} interaction:`, error);
          throw error;
        }

      } catch (error) {
        console.error('Error saving interaction:', error);
        Swal.fire('Error', 'to save interaction', 'error');
      }
    }
  }
}
</script>